import { CounterData } from '@/api/models/counters/lib/counters.types'
import { canEditCounter } from '@/components/pages/counter/utils/canEditCounter'

export const useCountersAvailability = (countersList?: CounterData[]) => {
  return countersList?.some(canEditCounter)
}
